<template>
  <div id="index">
    <section class="topCar clear">
      <div class="float-f today">
        <p @click="canvasClick" class="p1">Today</p>
        <!--<p class="p2"><img src="../../static/img/location.png">北京市</p>-->
        <p class="p2">{{this.currentTime}}</p>
      </div>
      <div @click="toMy" class="float-r my-img">
        <img src="../../static/img/my.png">
      </div>
    </section>
    <!--  中间导航栏 -->
    <section class="nav">
      <div>
        <img @click="repair" src="../../static/img/baoxiu.png">
      </div>
      <div>
        <img @click="toPay" src="../../static/img/jiaofei.png">
      </div>
      <div>
        <img @click="complain" src="../../static/img/tousu.png">
      </div>
    </section>
    <!--弹窗-->
    <div v-if="sec4" class="sec4"></div>
    <section v-if="popUp" class="popUp">
      <img @click="close" src="../../static/img/close.png">
      <p v-if="pa" class="pa">您还未绑定手机号，请立即去绑定</p>
      <p v-if="pb" class="pb">您还没有房产信息，请点击获取房产或点击更换手机号</p>
      <div v-if="pa" class="diva">
        <input @click="bangDing" type="text" value="绑定">
      </div>
      <div v-if="pb" class="divb clear">
        <input @click="fangchanxinxi" class="float-f" type="text" value="同步房产">
        <input @click="bangDing" class="float-r" type="text" value="更换手机号">
      </div>
    </section>
  </div>
</template>
<script>
  export default {
    data() {
      return {
        sec4: false,
        popUp: false,
        pa: false,
        pb: false,
        sliderinit: {
          currentPage: 0,
          thresholdDistance: 100,
          thresholdTime: 300,
          autoplay: 2000,
          loop: true,
          infinite: 1,
          slidesToScroll: 1,
          timingFunction: 'ease',
          duration: 500,
          typeNum: 0
        },
        currentTime: ''
      }
    },
    created: function () {
      //setInterval(this.scroll, 2500)
      let now = new Date();
      let year = now.getFullYear();
      let month = now.getMonth();
      let date = now.getDate();
      this.currentTime = year + '年' + (month + 1) + '月' + date + '日 '
    },
    methods: {
      canvasClick(){
        this.$router.push({name: 'mobileHomeInspection'})
      },
      // 点击我的 跳转我的页面，获取关注的人的微信的信息包括 头像和昵称
      toMy() {//我的
        this.$router.push({name: 'my'})
      },
      close() {
        this.popUp = false
        this.sec4 = false
      },
      bangDing() {
        this.$router.push({name: 'checkTel'})
      },
      fangchanxinxi() {
        this.$router.push({name: 'houseInfo'})
      },
      initAddress() {
        const _this = this
        _this.postRequest('house/queryByUserId', {}, function (data) {
          if (data.length <= 0) {
            //弹窗
            _this.pb = true
            _this.popUp = true
            _this.sec4 = true
          } else {
            sessionStorage.setItem('el', data[0].name)
            sessionStorage.setItem('houseid', data[0].id)
            switch (_this.typeNum) {
              case 1:
                _this.$router.push({
                  name: 'repair',
                  params: {
                    house: data
                  }
                })
                break;
              case 2:
                _this.$router.push({
                  name: 'complain',
                  params: {
                    house: data
                  }
                })
                break;
              case 3:
                _this.$router.push({
                  name: 'payXinYuan',
                  params: {
                    house: data
                  }
                })
                break;
            }
          }
        })
      },
      acquireIphone() {
        const _this = this
        _this.postRequest('user/currentUserDetail ', {}, function (data) {
          if (data.phone) {
            _this.initAddress()
          } else {
            //弹窗
            _this.pa = true
            _this.popUp = true
            _this.sec4 = true
          }
        })
      },
      scroll() {
        this.animate = true
        setTimeout(() => {
          this.marqueeList.push(this.marqueeList[0])
          this.marqueeList.shift()
          this.animate = false
        }, 1500)
      },
      repair() {//报修
        this.typeNum = 1
        this.acquireIphone()
      },
      complain() {//投诉
        this.typeNum = 2
        this.acquireIphone()
      },
      comList() {
        this.$router.push({name: 'comList'})
      },
      toPay() {//缴费
        this.typeNum = 3
        this.acquireIphone()
      },
      toDetail() {
        this.$router.push({name: 'hotNoteDetail'})
      }
    }
  }
</script>
<style scoped>
  .nav {
    text-align: center;
  }

  .nav div img {
    width: 470px;
    height: 270px;
    margin: 30px 0;
  }

  .today {
    margin: 29px;
  }

  .today .p1 {
    font-size: 48px;
    color: rgba(51, 51, 51, 1);
    font-weight: 900;
    margin-bottom: 20px;
  }

  .today .p2 {
    font-size: 28px;
    margin-left: 10px;
    color: rgba(153, 153, 153, 1);
  }

  .today .p2 img {
    width: 30px;
    height: 36px;
    vertical-align: middle;
    margin-right: 23px;
  }

  .my-img img {
    width: 80px;
    height: 80px;
    margin: 50px 32px 0 0;
  }

  /*遮罩样式*/
  .sec4 {
    width: 100%;
    height: 1334px;
    background: #000000;
    opacity: .4;
    z-index: 10;
    position: fixed;
    top: 0;
  }

  .clear {
    overflow: hidden;
    zoom: 1;
  }

  .float-f {
    float: left;
  }

  .float-r {
    float: right;
  }

  .popUp {
    z-index: 20;
    background: #fff;
    border-radius: 10px;
    width: 88%;
    height: 302px;
    position: fixed;
    top: 480px;
    left: 50%;
    transform: translateX(-50%);
  }

  .popUp img {
    width: 28px;
    height: 28px;
    margin-left: 620px;
    margin-top: 16px;
  }

  /*绑定弹框*/
  .popUp .pa {
    line-height: 70px;
    font-size: 28px;
    text-align: center;
  }

  .popUp .diva input {
    width: 38%;
    height: 68px;
    font-size: 30px;
    text-align: center;
    background: rgb(27, 130, 209);
    border-radius: 90px;
    color: #fff;
    margin: 60px 0 0 200px;
  }

  /*获取房产 和 更换手机号 弹框*/
  .popUp .pb {
    width: 75%;
    padding: 0 40px;
    text-align: center;
    margin: 30px 0;
    margin-left: 50%;
    transform: translateX(-50%);
    font-size: 28px;
  }

  .popUp .divb {
    margin-top: -10px;
    margin: 0 50px;
  }

  .popUp .divb input {
    width: 38%;
    height: 68px;
    font-size: 30px;
    text-align: center;
    background: rgb(27, 130, 209);
    border-radius: 90px;
    color: #fff;
    margin: 10px 0;
  }

  /* 固定二倍图尺寸 */
  .more2 {
    width: 12px;
    height: 21px;
  }

  .fl {
    float: left;
  }

  #index {
    width: 100%;
    background-color: #fff;
    text-align: left;
  }

</style>



// WEBPACK FOOTER //
// src/components/homePage.vue